module.exports = __webpack_public_path__ + "static/media/Building.ba09da38.svg";